export default "__VITE_ASSET__C4OookT1__"